import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
  },
  iconContainerStyle: {
    alignSelf: 'flex-start',
    marginTop: 5,
    padding: 8,
    borderRadius: 6.2,
    marginRight: 12,
  },
  iconContainerBgStyle: colors => ({
    backgroundColor: colors.myPlanIconBackground,
  }),
  usageDataViewStyle: {
    flexGrow: 1,
    flexBasis: 0,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  rightTextContainerStyle: {
    flexDirection: 'row',
  },
  usageValuesContainerViewStyle: {
    flexDirection: 'row',
  },
  dataPercentageContainerStyle: (percentageValue, withIcon) => ({
    justifyContent: percentageValue ? 'space-between' : 'center',
    height: withIcon ? 33 : null,
  }),
  leftTextStyle: {
    fontSize: 18,
    lineHeight: 26,
  },
  headerTextContainerStyle: leftText => ({
    flex: 1,
    marginTop: 2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: leftText ? 'space-between' : 'flex-end',
  }),
  percentageIndicatorContainerStyle: {
    marginTop: 6.2,
  },
  percentageTextStyle: theme => ({
    fontSize: 18,
    color: theme.colors.sectionItemTextColor,
    lineHeight: 26,
  }),
  rightTextStyle: colors => ({
    fontSize: 18,
    marginRight: 3,
    lineHeight: 26,
    color: colors.myPlanUsageValues,
  }),
  addUsageButtonStyle: {
    marginTop: 22,
  },
  addUsageButtonTextStyle: {
    fontSize: 18.8,
    lineHeight: 25,
  },
});
